import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, catchError, map, of, switchMap, tap } from 'rxjs';
import { User, UserRole } from '../models/user.model';
import { AuthWithPassword } from '../models/auth-password';
import { UserService } from './user.service';
import { ApiService } from './api.service';


@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private authSystem: AuthWithPassword;

  isAuthenticatedValue: boolean | null = null;

  constructor(
    private router: Router,
    private userService: UserService,
    private api: ApiService
    ) {
    this.authSystem = this.createAuthSystemInstance();
    this.authSystem.userAuthToken$.subscribe(token => this.userService.token$.next(token));
    this.api.logoutHandler = () => {
      this.signOut();
    }
    this.userService.signOut = () => {
      this.signOut();
    }
  }

  createAuthSystemInstance(): AuthWithPassword {
    return new AuthWithPassword();
  }

  get userAuthToken$(): BehaviorSubject<string> {
    return this.userService.token$;
  }

  get user$(): BehaviorSubject<User | null> {
    return this.userService.user$;
  }

  /** Entra com email e password. */
  login(email: string, password: string): Observable<boolean> {
    return this.authSystem.login(email, password);
  }

  /** Retoma a sessao guardada, se ainda for valida. */
  signIn(): Observable<boolean> {
    return this.authSystem.signIn();
  }

  signOut(): void {
    this.authSystem.signOut();
    
  }

  isAuthTokenValid(): boolean{
    return this.authSystem.isAuthTokenValid();
  }

  getUpdatedAuthToken(): Observable<string | null>{
    const isAuthenticatedValue = this.isAuthTokenValid();
    if(!isAuthenticatedValue){
      // alert('stop');
      return this.authSystem.idToken().pipe(tap(token => {
        this.authSystem.userAuthToken$.next(token ?? '');
      }));
    }

    return of(this.authSystem.userAuthToken$.getValue());
  }
}
